/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowsUpDownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAzUlEQVR4nO2VSwoCMQyG5xAqHqnINMksSiJ4IL2DHmRWgoOoSx94HaV16sLH2MlOnUDIJvk/krZplv2kGef6Fnlnibd5Pu415VqSNSBX7cSJD0By8W5RziPnhu/yY55KPAWSDPDigHIMBTGSdz7Vcf9qXMkAS7KM4gFWFxbFZHDvCqVUA4Bk7iFe/LHQ3LorgWSqBmgLoQNk3Yj+7xZZ5MXnB8kzPYB0KyUZYJRLMRnQtNaTxVMOzzxBWogHAHJlSVZNOfFrBZRNK/GvsisR2AI7j2e/kwAAAABJRU5ErkJggg==)
 */
export const ArrowsUpDownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.3 21.7a1 1 0 0 0 1.4 0l4-4a1 1 0 0 0-1.4-1.4L18 18.58V3a1 1 0 1 0-2 0v15.59l-2.3-2.3a1 1 0 0 0-1.4 1.42l4 4ZM6.3 2.3a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L8 5.42V21a1 1 0 1 1-2 0V5.41l-2.3 2.3a1 1 0 0 1-1.4-1.42l4-4Z"
        className={colorClass}
      />
    </svg>
  );
};
